
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[site]/[[...path]]",
      function () {
        return require("private-next-pages/_sites/[site]/[[...path]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/[site]/[[...path]]"])
      });
    }
  